import { render, staticRenderFns } from "./EditCourseArticle.vue?vue&type=template&id=7e390f40&scoped=true"
import script from "./EditCourseArticle.vue?vue&type=script&lang=js"
export * from "./EditCourseArticle.vue?vue&type=script&lang=js"
import style0 from "./EditCourseArticle.vue?vue&type=style&index=0&id=7e390f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e390f40",
  null
  
)

export default component.exports